// extracted by mini-css-extract-plugin
export var sliderRange = "_s9-2";
export var sliderRoot = "_s9-0";
export var sliderThumb = "_s9-3";
export var sliderTrack = "_s9-1";